// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "campaign".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { campaignStatusValues, campaignTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "campaign" table (1:1 with a DB row, on the wire). */
export const campaignAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    type: z.enum(campaignTypeValues),
    status: z.enum(campaignStatusValues),
    channels: z.array(z.string()),
    segmentId: z.string().nullable(),
    sequenceId: z.string().nullable(),
    scheduledAt: z.string().datetime().nullable(),
    sentAt: z.string().datetime().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=campaign.js.map